import { boolean, dateTime, defineAction, enumerated, object, string } from '~/prix'
import agentRequestCloseAction from './agentRequestClose.action.json'

const agentRequestCloseDefinition = defineAction({
  ...agentRequestCloseAction,
  userActivityLog: true,
  input: object({
    entrepreneurCpf: string(),
    agentCpf: string(),
    cancellationReason: string(),
    cancellationReasonDetails: string().isOptional(),
  }),
  output: object({
    success: boolean(),
    state: enumerated({
      canceled: 'canceled',
    }),
    closedAt: dateTime(),
  }),
})

export default agentRequestCloseDefinition
